export function AddDataTypeRequestObject(this: any): any {
  return {
    name: this.name,
    storedProcedure: this.storedProcedure,
    description: this.description,
  };
}
